module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_normal.1001.jpg.08a6bcb2.webp";